// extracted by mini-css-extract-plugin
export default {"container":"user-letter_container__1a8LM","letter":"user-letter_letter__H-oKQ","name":"user-letter_name__tkS73","defisTheme":"user-letter_defisTheme__2H-42"};